// JavaScript Document
//components/configuration/PowerPicker.js
import React from 'react';
//import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
//import AppBar from '@material-ui/core/AppBar';
//import Typography from '@material-ui/core/Typography';
//import Box from '@material-ui/core/Box';
//import Card from '@material-ui/core/Card';
//import CardActions from '@material-ui/core/CardActions';
//import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
//import dsutils from '../../standard/daysettings/Utils';
//const utils = require('../../standard/daysettings/Utils');
import dfonts from './Fonts';
//const fonts = require('./Fonts');
//const utils = dsutils();
const fonts = dfonts();

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 130,
  },
  fontSizeField : {
	  marginLeft : theme.spacing(1),
	  marginRight : theme.spacing(1),
	  width: 60
  },
  gridder: {
	  padding: theme.spacing(3)
  }
}));

export default function TextStamp(props) {
  	const classes = useStyles();
  	const {defaultFont, onSubmit} = props;
	const [text, setText] = React.useState('');
	const [font, setFont] = React.useState(1);
	const [mounted, setMounted] = React.useState(false);
 
 	//changes to text
  	const handleTextChange = (e) => {
	  	setText(e.target.value);
  	};
	
	//changes to font
	const handleFontChange = (e) => {
		setFont(e.target.value);
	}
	
	//Set default font on mount, if available
  	React.useEffect(() => {
		if(!mounted){
			if(defaultFont){
				setFont(defaultFont);
			}
			setMounted(true);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props]);
	
	//Handle submit/place click
	const handlePlace = (e) => {
		let stamp = compileStamp();
		if(onSubmit){
			onSubmit(stamp);
		}
	};
	
	//handle compile stamp
	const compileStamp = () => {
		return fonts.control.text.toMap(text, font);
	}

  return (
	  <Grid container justifyContent="space-around" className={classes.gridder}>
    		<TextField
        		id="text"
        		label="Text"
	  			value={text}
        		className={classes.textField}
	  			onChange={handleTextChange}
	  			autoFocus={true}
	  			required={true}
        		InputLabelProps={{
	  				shrink: true,
        		}}
      		/>
	  		<TextField
        		id="fontSize"
        		label="Size"
        		type="number"
	  			onChange={handleFontChange}
	  			value={font}
	  			required={true}
        		className={classes.fontSizeField}
        		InputLabelProps={{
	  				shrink: true,
        		}}
        		inputProps={{
	  				step: 1, // 5 min
	  				min: 1,
	  				max: fonts.fonts.length
        		}}
      		/>
	  		<Button variant="contained" color="primary" onClick={handlePlace}>
  				Place
	  		</Button>
	  </Grid>
  );
}
